import React, { Component } from "react";
import { Table, Spin, Col, Row, Select, Input } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";

const { Option } = Select;
const { Search } = Input;
const searchOptions = {
  componentRestrictions: { country: "in" }
};

export default class ClinicsView extends Component {
  render() {
    const { details, navigateToClinicDetails, isProcessing } = this.props;

    const columns = [
      {
        title: "Name",
        align: "left",
        dataIndex: "name",
        key: "name",
        render: record => <div> {record || "--"}</div>
      },
      {
        title: "Mobile Number",
        dataIndex: "phone_number",
        key: "phone_number",
        align: "left"
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        align: "left"
      }
    ];
    let source = [];
    if (details && details.clinics) {
      source = details.clinics;
    }

    return (
      <Spin spinning={isProcessing}>
        <div className="content-container">
          <div className="kc-block white-bg round-borders-4x">
            <Table
              onRowClick={record => navigateToClinicDetails(record.id)}
              columns={columns}
              dataSource={source}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </Spin>
    );
  }
}
